module.exports = __webpack_public_path__ + "static/media/tmcf-black.97317c35.svg";